import ConfigApi from '../../services/ConfigApi';
import Config from '../../Config';
import '../../../../core_modules/Product/ProductState.js';

// ACTION TYPES
export const PRODUCT_SET_CENTER = 'PRODUCT_SET_CENTER';
export const PRODUCT_SET_ZOOM = 'PRODUCT_SET_ZOOM';
export const PRODUCT_UPDATE_GEO = 'PRODUCT_UPDATE_GEO';

export const PRODUCT_LOAD_CONFIG = 'PRODUCT_LOAD_CONFIG';
export const PRODUCT_LOAD_CONFIG_COMPLETED = 'PRODUCT_LOAD_CONFIG_COMPLETED';
export const PRODUCT_LOAD_CONFIG_FAILED = 'PRODUCT_LOAD_CONFIG_FAILED';

export const PRODUCT_SET_ACTIVE_LAYER = 'PRODUCT_SET_ACTIVE_LAYER';
export const PRODUCT_UPDATE_FAVORITES = 'PRODUCT_UPDATE_FAVORITES';

export const PRODUCT_UPDATE_ZOOM_LIMITS = 'PRODUCT_UPDATE_ZOOM_LIMITS';
export const PRODUCT_UPDATE_MAXBOUNDS = 'PRODUCT_UPDATE_MAXBOUNDS';

export const PRODUCT_SHOW_FAVORITES = 'MapTool/ProductState/PRODUCT_SHOW_FAVORITES';
export const PRODUCT_HIDE_FAVORITES = 'MapTool/ProductState/PRODUCT_HIDE_FAVORITES';
export const PRODUCT_SHOW_WARNINGS = 'MapTool/ProductState/PRODUCT_SHOW_WARNINGS';
export const PRODUCT_HIDE_WARNINGS = 'MapTool/ProductState/PRODUCT_HIDE_WARNINGS';

export const PRODUCT_TOGGLE_DESCRIPTION = 'MapTool/ProductState/PRODUCT_TOGGLE_DESCRIPTION';

// ACTIONS
export function setNewCenter(center) {
  return { type: PRODUCT_SET_CENTER, center };
}

export function setNewZoom(zoom) {
  return { type: PRODUCT_SET_ZOOM, zoom };
}

export function updateGeo(geo) {
  return { type: PRODUCT_UPDATE_GEO, geo };
}

export function loadProductConfigCompleted(payload) {
  return { type: PRODUCT_LOAD_CONFIG_COMPLETED, payload };
}

export function loadProductConfigFailed(payload) {
  return { type: PRODUCT_LOAD_CONFIG_FAILED, payload };
}

export function updateZoomLimits(zoomRange) {
  return { type: PRODUCT_UPDATE_ZOOM_LIMITS, zoomRange };
}

export function updateMaxBounds(maxBounds) {
  return { type: PRODUCT_UPDATE_MAXBOUNDS, maxBounds };
}

/**
 * helper function to extend loaded config
 * @param  {Object} data loaded config
 * @return {Object} extended config
 */
function extendConfig(data) {
  const nextState = data;
  delete nextState.basemaps; // we only use config from AppConfig in maptool App since it's part of the menu
  return nextState;
}

export function loadProductConfig(params) {
  if (!params || !params.id) {
    return false;
  }

  return (dispatch) => {
    dispatch({ type: PRODUCT_LOAD_CONFIG });

    ConfigApi.loadProductConfig(params)
      .then((res) => {
        const nextState = extendConfig(res.data);
        dispatch(loadProductConfigCompleted(nextState));
      })
      .catch((err) => {
        if (process.env.IS_DEV) {
          console.error(err);
        }
        throw new Error(err);
      });
  };
}

export function setActiveLayer(basemap) {
  return { type: PRODUCT_SET_ACTIVE_LAYER, basemap };
}

export function showFavoritesOnMap(favorites) {
  return { type: PRODUCT_UPDATE_FAVORITES, favorites };
}

export function toggleDescription() {
  return { type: PRODUCT_TOGGLE_DESCRIPTION };
}


export const actions = {
  setNewZoom,
  updateZoomLimits,
  updateMaxBounds,
  loadProductConfig,
  setActiveLayer,
  showFavoritesOnMap,
};

// REDUCER
export default function reducer(state = Config.DEFAULT_PRODUCT_CONFIG, action) {
  switch (action.type) {
    case PRODUCT_SET_CENTER:
      return Object.assign({}, state, { center: action.center });
    case PRODUCT_SET_ZOOM:
      return Object.assign({}, state, { zoom: action.zoom });
    case PRODUCT_UPDATE_GEO:
      return Object.assign({}, state, { center: [action.geo[0], action.geo[1]], zoom: action.geo[2] });
    case PRODUCT_UPDATE_ZOOM_LIMITS:
      return Object.assign({}, state, {
        minZoom: action.zoomRange.min,
        maxZoom: action.zoomRange.max,
      });
    case PRODUCT_UPDATE_MAXBOUNDS:
      return Object.assign({}, state, { maxBounds: action.maxBounds });
    case PRODUCT_LOAD_CONFIG_COMPLETED: {
      if (window.$) {
        window.$(`#${Config.rootDivId}`).trigger('product_load.maptool', { product: action.payload });
      }
      return Object.assign({}, state, action.payload);
    }
    case PRODUCT_SET_ACTIVE_LAYER:
      return Object.assign({}, state, { basemap: action.basemap });
    case PRODUCT_UPDATE_FAVORITES:
      return Object.assign({}, state, { favorites: action.favorites });

    case PRODUCT_SHOW_FAVORITES:
      return Object.assign({}, state, { showFavorites: true });
    case PRODUCT_HIDE_FAVORITES:
      return Object.assign({}, state, { showFavorites: false });
    case PRODUCT_SHOW_WARNINGS:
      return Object.assign({}, state, { showWarnings: true });
    case PRODUCT_HIDE_WARNINGS:
      return Object.assign({}, state, { showWarnings: false });

    case PRODUCT_TOGGLE_DESCRIPTION:
      return Object.assign({}, state, { isDescriptionOpen: !state.isDescriptionOpen });

    default:
      return state;
  }
}



/** WEBPACK FOOTER **
 ** ./apps/maptool/modules/Product/ProductState.js
 **/